export default "__VITE_ASSET__Kbp2rYi0__"